import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CircleButton from '../components/CircleButton';
import RecordingBtn from '../assets/img/recording-btn.png';

const StyledFooterPanel = styled.div`
  position: absolute;
  display: flex;
  bottom: 0;
  left: 50%;
  width: 748px;
  height: 420px;
  background: none;
  justify-content: center;
  border-radius: 50%;
  transform: translate3d(-50%, 50%, 0);

  > * {
    transform: translateY(-50%);
  }

  .recording-img {
    width: 100%;  
  }
`;

const ButtonText = styled.p`
  position: absolute;
  top: 40px;
  font-family: 'Speedee Bold';
  font-size: 20px;
  font-weight: bold;
  line-height: 0.95em;
  letter-spacing: -0.05em;
  margin: 26px 0 0 0;
`;

const CountdownWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  margin: -58px -16px 0;

  > img {
    &#img_pickles {
      position: absolute;
      top: -40px;
      right: -16px;
  }

  @keyframes fadeInScale {
    0% {
      opacity: 0;
      transform: scale(0.8)
    }
    100% {
      opacity: 1;
      transform: scale(1)
    }
  }
`;

function Countdown({ ...props }) {
  const { setPage } = props;
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (count > 0) {
      const timerId = setTimeout(() => setCount(count - 1), 1000);
      return () => clearTimeout(timerId);
    } else if (count === 0) {
      setPage('timer-chant');
      setCount(null);
    }
  }, [count, setPage]);

  return (
    <CountdownWrapper>
      <div style={{ position: 'absolute', top: (count === 0 ? 200 : 0), left: 0, width: '100%', height: '100%', fontSize: (count === 0 ? '115.29px' : '450px'), fontWeight: 'bold', textAlign: 'center', fontFamily: 'Speedee Bold', background: count % 2 === 0 ? '#FFFFFF' : '#FFBC0D', color: count % 2 === 0 ? '#FFBC0D' : '#FFFFFF'}}>
        <span style={{animation: `fadeInScale 1s linear forwards infinite`, display: 'block'}}>{count}</span>
      </div>
      <div style={{ position: 'absolute', bottom: '150px', left: 0, width: '100%', textAlign: 'center', fontSize: 60, lineHeight: '95%', letterSpacing: '-0.03em', fontFamily: 'Speedee Bold', color: '#2D2D2D' }}>
        Get ready
      </div>
      { count === 0 && (
        <StyledFooterPanel>
          <CircleButton>
            <img src={RecordingBtn} alt="Recording button" className='recording-img'/>
          </CircleButton>
          <ButtonText>Recording...</ButtonText>
        </StyledFooterPanel>
      ) }
    </CountdownWrapper>
  );
}

export default Countdown;